import React from 'react';
import PropTypes from 'prop-types';
import {
    StatcastWrapper,
    StatcastStat,
    StatcastLabel,
    StatcastValue,
    StatcastUnit
} from './Summary.style';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';

const Statcast = ({
    lastPlayEvent,
    isMobile
}) => {
    const {
        hitData: {
            totalDistance,
            launchSpeed,
            launchAngle
        } = {}
    } = lastPlayEvent;

    const validTotalDistance = typeof totalDistance !== 'undefined' && totalDistance !== null;
    const validLaunchSpeed = typeof launchSpeed !== 'undefined' && launchSpeed !== null;
    const validLaunchAngle = typeof launchAngle !== 'undefined' && launchAngle !== null;

    if (!(validTotalDistance || validLaunchSpeed || validLaunchAngle)) {
        return null;
    }
    const distanceTitleLabel = useTranslator('label_distance', 'Distance');
    const velocityTitleLabel = useTranslator('label_exit_velocity', 'Exit Velocity');
    const angleTitleLabel = useTranslator('label_launch_angle', 'Launch Angle');

    const distanceUnit = useTranslator('label_feet_abbrev', 'ft');
    const velocityUnit = 'mph'; // no translation needed
    const angleUnit = 'deg';

    return (
        <StatcastWrapper>

            {validLaunchSpeed ? <StatcastStat>
                <StatcastLabel>
                    {velocityTitleLabel}
                </StatcastLabel>
                <StatcastValue isMobile={isMobile}>
                    {launchSpeed}
                    <StatcastUnit>
                        {velocityUnit}
                    </StatcastUnit>
                </StatcastValue>
            </StatcastStat> : null}

            {validTotalDistance ? <StatcastStat>
                <StatcastLabel>
                    {distanceTitleLabel}
                </StatcastLabel>
                <StatcastValue isMobile={isMobile}>
                    {totalDistance}
                    <StatcastUnit>
                        {distanceUnit}
                    </StatcastUnit>
                </StatcastValue>
            </StatcastStat> : null}

            {validLaunchAngle ? <StatcastStat>
                <StatcastLabel>
                    {angleTitleLabel}
                </StatcastLabel>
                <StatcastValue isMobile={isMobile}>
                    {launchAngle}
                    <StatcastUnit>
                        {angleUnit}
                    </StatcastUnit>
                </StatcastValue>
            </StatcastStat> : null}

        </StatcastWrapper>
    );
};

Statcast.propTypes = {
    lastPlayEvent: PropTypes.object
};

export default Statcast;
